import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from "@angular/core";
import {FormControl} from "@angular/forms";

@Component({
    selector: "fhm-state-select-control",
    templateUrl: "./state-select-control.component.html",
    styleUrls: ["./state-select-control.component.scss"],
    standalone: false
})
export class StateSelectControlComponent implements OnChanges {
    @Output() public removed: EventEmitter<any> = new EventEmitter();

    @Output() public valueChange: EventEmitter<string> = new EventEmitter();

    @Input() public value: string;

    @Input() disabled: boolean;
    public options: any[] = [
        {label: "QLD", value: "QLD"},
        {label: "NSW", value: "NSW"},
        {label: "VIC", value: "VIC"},
        {label: "WA", value: "WA"},
        {label: "SA", value: "SA"},
        {label: "NT", value: "NT"},
        {label: "ACT", value: "ACT"},
        {label: "TAS", value: "TAS"}];

    public selectedValue: any;



    public updateStateOnValueChange(): void {
        if (this.selectedValue) {
            this.valueChange.emit(this.selectedValue["value"]);
        } else {
            this.valueChange.emit();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.selectedValue = undefined;
        this.options.forEach(d => {
            if (d.value === this.value) {
                this.selectedValue = d;
            }
        });
    }

}
